export default {
  header: {
    home: '首页',
    aboutUs: '公司介绍',
    productService: '产品服务 ',
    veterinary: '一类新兽药研发管线',
    highEnd: '特色制剂研发平台',
    healthcare: '功能保健品',
    rdCenter: '研发中心',
    ourTeam: '公司团队',
    news: '新闻资讯',
    companyNews: '公司新闻',
    industryNews: '行业资讯',
    contactUs: '联系我们',
    Message: '咨询留言',
  },

  footer1: '订阅注册',
  footer2: '揭秘养宠最新产品',
  footer3: '免费注册',
  footer4: '南京派特美生科技有限公司 版权所有',
  footer5: '输入您的邮箱地址',
  home1: '我们致力于',
  home2: '以科技创新和品质之力护佑全球宠物',
  home3: '了解详情 ',
  home4: '在研项目',
  home5: '一类创新药项目',
  home6: '产业资源',
  home7: '聚焦宠物创新服务',
  home8: '作为宠物保健领域的新兴企业，我们以严谨的科学态度致力于宠物疾病预防、治疗药物的研发、生产和销售，用实际行动体现对于生命健康的敬畏，为宠物和主人美满的家庭生活提供支撑的力量（保障）。',
  home9: '创新服务',
  home10: '核心优势',
  home11: '一类新兽药研发管线',
  home12: '创新研发',
  home13: '引领宠物医疗市场',
  home14: '特色制剂研发平台',
  home15: '科技创新',
  home16: '提供高品质的诊疗体验',
  home17: '功能保健品',
  home18: '提供高质量产品',
  home19: '升级宠物生活品质',
  home20: '预防',
  home21: '主要指宠物疫苗和宠物体检，企业发展未来的增长极',
  home22: '治疗',
  home23: '宠物疾病的治疗，涉及宠物药品的研发、生产和销售，企业发展的主要支柱',
  home24: '诊疗',
  home25: '宠物医院、互联网宠物医疗、快速诊断试纸，企业发展的潜在重点',
  home27: '保健',
  home29: '宠物康复及保健的用品、器械和功能性食品，是企业发展的初始动力',
  home30: '敬请期待',
  home31: '针对市场痛点',
  home32: '提供解决方案',
  home33: '公司团队',
  home34: '专注于自主研发创新药物研发能力及高效的运营能力，',
  home35: '自主研发了一系列多元化而具有协同效应的产品管线',
  home36: '整体发展规划',
  home37: '派美核心竞争力在于<span class="highlight-green">医疗需求和科研成果的快速转化能力</span>，通过持续的研发投入和市场挖掘，将会逐步形成有自身特色的产品管线，成为细分赛道的龙头企业，最终实现<span class="highlight-orange">全球化动保集团</span>的愿景。',
  home38: '派美医疗',
  home39: '专注于宠物化药、生物药品和先进治疗方法的研发、生产和销售，未来保持向经济动物发展的可能',
  // home40/home41: 灵舟器械 —— 已从"整体发展规划"轨道图移除，词条保留供其他页面使用
  home40: '灵舟器械',
  home41: '专门开发针对宠物诊疗、康复过程中使用到的创新医疗器械和创新产品',
  home42: '派瑞乐',
  home43: '中国宠物愈后康复、特医食品和智能健康用品领军品牌，未来打造成全球领先的宠物保健品牌',
  home44: '双轮驱动，内外并进',

  // 企业文化体系
  culture_title: '企业文化体系',
  culture_mission_label: '使命 Mission',
  culture_mission_text: '以科技创新和品质之力护佑全球宠物',
  culture_vision_label: '愿景 Vision',
  culture_vision_text: '成为全球领先、值得信赖的动保企业',
  culture_values_label: '核心价值观 Core Values',
  culture_values_text: '创新、卓越、积极、分享',

  founders_title: '创始股东 合作共赢',
  founder1_name: '药石科技',
  founder1_code: '300725',
  founder1_role: '先导化合物优化',
  founder1_desc: '利用自身优势资源，协助公司完成先导化合物筛选、结构优化、工艺优化、制剂研究等相关工作及中试生产。',
  founder2_name: '集萃药康',
  founder2_code: '688046',
  founder2_role: '临床前药效',
  founder2_desc: '利用自身优势资源，协助公司完成临床前不同阶段的生物模型的建立和动物实验的相关工作。',
  founder3_name: '中旗股份',
  founder3_code: '300575',
  founder3_role: '生产制造',
  founder3_desc: '利用自身优势资源，协助公司完成临床前及未来商业化生产不同阶段的生产制造等相关工作。',
  founder4_name: '江苏南创化学与生命健康研究院',
  founder4_role: '技术支撑',
  founder4_desc: '由南京大学现代配位化学国家重点实验室科学家郭子建院士团队，南京市江北新区生物医药谷，南京药石科技股份有限公司三方共同组建的新型研发机构。',

  marketing_title: '派美营销体系',
  marketing1_name: '国内线下自营渠道',
  marketing1_desc: '已经建立起以南京为中心，四个大区的销售格局，主要针对重点医院和诊所进行学术推广和品牌宣传。',
  marketing2_name: '国内线下经销商渠道',
  marketing2_desc: '积极拓展有实力的经销商加盟销售网络，扩大品牌影响力。',
  marketing3_name: '国内线上渠道',
  marketing3_desc: '已经建立电商全域营销体系，针对兴趣电商和货架电商的不同需求，建立专门团队进行业务拓展，塑造品牌。',
  marketing4_name: '海外线上自营渠道',
  marketing4_desc: '前期主要以亚马逊官方店为主要销售渠道，争取更多的产品曝光，提高产品知名度。',

  productService_title: '产品服务',
  product_intro: '围绕"一体两翼"战略，持续布局一类创新宠物生物制品，辅以医疗器械和保健品的合作开发，为宠物病患带来更多健康的希望，为全球动物健康水平提升和高质量发展贡献坚实力量。',
  product_pharma_name: '派美制药',
  product_pharma_desc: '专注于宠物化药和生物药品的研发、生产和销售，未来保持向经济动物发展的可能。',
  product_healthcare_name: '派美保健',
  product_healthcare_desc: '专注于宠物康复及保健的用品、器械和功能性食品，是企业发展的初始动力。',
  product_devices_name: '灵舟器械',
  product_devices_desc: '专门开发针对宠物诊疗、康复过程中使用到的创新医疗器械和创新产品。',
  product_more: '了解更多',
  bigData_platform1_title: '软咀嚼片技术平台',
  bigData_platform1_subtitle: '与普通片剂相比，软咀嚼片具有良好的口感',
  bigData_platform1_point1: '攻克软咀嚼片制剂难度，打破进口垄断。',
  bigData_platform1_body: '国内在售的产品中，质量稳定且客户反馈较好的软咀嚼片还是全部被进口药企占据，国内还未有企业能成功申报该剂型。',
  bigData_platform2_title: '味道遮蔽技术平台',
  bigData_platform2_subtitle: '为药物提供一个物理屏障（如包衣等）',
  bigData_platform2_point1: '阻止药物在口腔内的溶解和释放',
  bigData_platform2_point2: '掩盖药物的味道',
  bigData_platform2_point3: '防潮避光，提高药物的稳定性',
  bigData_platform2_point4: '避免宠物不愿服用的情况',
  productService_section_title: '提升宠物疾病预防 呵护"家人"健康',
  productService_section_body: '我们秉承科技创新、品质至上的准则，提供具有明确健康获益的专业动物产品，携手优秀的动物医师资源提供专业的市场推广、临床教育指导及服务，共同维护和提升动物健康福祉并回馈社会。呵护全球宠物健康，携手爱宠人士支持、推进中国宠物行业的发展；以创新、品质之力，结合强烈的社会责任感，实现企业伟大目标：全球宠物和爱宠人士美好生活的品质之选！',

  companyIntro_title: '公司介绍',
  introduct1: '以科技创新和品质之力护佑全球宠物',
  introduct2_p1: '南京派特美生科技有限公司是一家专注于宠物医疗领域的高新技术生物技术公司，公司秉承着以科技创新和品质之力护佑全球宠物的愿景，在药石科技(300725)、药康生物(688046)和中旗股份(300575)三家上市公司的支持下，按照人用创新药品的研发思路，结合团队丰富的宠物临床经验和资源，快速的推进了宠物创新药物的研发，以一类创新宠物药品和高端制剂平台为突破口，仿创结合，最终满足未被满足的临床需求，解决宠物治疗领域缺医少药的状况。',
  introduct2_p2: '同时，公司还采用战略合作等不同方式布局了一类宠物生物制品，以最先进的生物科技给宠物病患带来更多健康的希望。公司着力在驱虫、肿瘤、中老年慢性病和自免这四个管线，同时辅以医疗器械和保健品的合作开发，以治未病的思路去促进宠物健康。确保短期内公司的产品和服务能通过公司的自有渠道和经销商渠道迅速铺满全国主要的宠物医疗机构以及海内外的线上平台，使得公司短、中、长期的产品矩阵能满足公司可持续发展的需求。',
  introduct2_p3: '未来公司会按照"一体两翼"的发展思路，在资金和技术的加持下，持续快速推进项目发展，尽早让中国品牌的宠物创新药物上市，既满足国内宠物的临床需求，未来也能服务于全球宠物。',
  introduct3: '加速开发出具有影响力的动物用药',

  smartTown1: '创新研发',
  smartTown2: '引领宠物医疗市场',
  smartTown3: '我们的药物研发团队拥有多年丰富的研发经验，涵盖了从先导化合物筛选优化、临床前研究到临床研究的全产业链。同时，借助行业顶尖的CRO机构和高校科研院所来加速项目的推进发展。最终以我们的创新产品来满足未被满足的临床需求，帮助全球兽医、宠物主、畜牧场主和公共卫生官员来提高动物健康水平。公司在研创新药物管线数条，开展项目十余个，后续还会根据临床和市场的需求，探索更多的可能。如需了解详情，请联系我们。',
  smartTown4: '基于适口性改善的高端制剂',
  smartTown5: '研发平台和改良型宠物药品研发',
  smartTown6: '为了解决宠物用药依从性差的难题，我们从适口性角度出发，开发了宠物药品适口性制剂平台，试图从根本上解决宠物喂药难，吸收性差的问题。公司制剂团队集合了十数位拥有多年药品制剂开发经验的专家和兽医师，共同来针对宠物的特性进行有针对性的研发。在研管线数条，开展项目数个，预计短时间内会推向市场。如需了解详情，请联系我们。',
  smartTown7: '提升宠物疾病预防',
  smartTown8: '呵护“家人”健康',
  smartTown9: '我们秉承科技创新、品质至上的准则，提供具有明确健康获益的专业动物保健产品，携手优秀的动物医师资源提供专业的市场推广、临床教育指导及服务，共同维护和提升动物健康福祉并回馈社会。 呵护全球宠物健康，携手爱宠人士支持、推进中国宠物保健行业的发展；以创新、品质之力，结合强烈的社会责任感，实现企业伟大目标：全球宠物和爱宠人士美好生活的品质之选！',

  service1: '丰富的药物化学+动物医学+临床经验，',
  service2: '研发全球首创及同类最佳的药物',
  service3: '南京派特美生科技有限公司科研团队拥有多名科学家、专家领导的研发团队，凭借自身丰富的药物化学、动物医学和临床经验，设计一系列具有前瞻性的研发管线。同时利用大量优秀的CRDMO资源，科学验证项目有效性，严谨解决安全、环保、成本、空间等问题，快速达到项目关键节点，高效的运营能力助推研发全球首创及同类最佳的药物，护佑宠物健康。',
  service4: '优质CRDMO资源，加速开发出具有影响力的宠物新药',

  groups1: "李轶",
  groups2: "创始人&CEO",
  groups3: "南开大学有机化学本科、硕士",
  groups4: "南京大学&荷兰MSM EMBA",
  groups5: "罗氏（中国）研发中心研究员",
  groups6: "参与创办药石科技(300725) 并在研发、销售、运营等不同部门历任副总裁、母公司轮值主席",
  groups7: "江苏南创化学与生命健康研究院有限公司创始人、董事长",
  groups8: "多个项目的天使投资人",
  groups9: "南京农业大学校外合作导师",
  groups10: "发表过十余篇文章和专利",

  news1: '开业盛典',
  news2: '2023年9月19日，南京派特美生科技有限公司（以下简称“派特美生”）举行开业大典。派特美生由南京药石科技股份有限公司（300725）、江苏集萃药康生物科技股份有限公司（688046）、中农宠物营养研究院（江苏）有限公司以及江苏南创化学与生命健康研究院有限公司等投资共建，致力于以科技创新和品质之力护佑全球宠物的创新型企业。派特美生以人用创新药的研发思路和品质控制，通过Biotech研发外包模式加自有工厂的形式，开发包括宠物药物、宠物康复器械及各类功能性食品。公司将不断推进科技创新，提高产品品质和服务水平，为宠物提供高品质的医疗保障和全面的康复和健康管理服务，愿景是成为全球宠物健康产业的领军企业。',
  news3: '敬请期待......',
  news4: '公司新闻',
  news5: '行业资讯',
  newsAttachTitle: '相关附件',
  newsPreview: '预览',
  newsDownload: '下载',

  contactUs1: '企业咨询，请联系',
  contactUs3: '邮箱：Public@petmedtech.com',
  contactUs10: '公司地址',
  contactUs11: '江苏省南京市江北新区新锦湖路3-1号中丹园一期A栋12F',
  news_grandopening_title: '开业盛典',
  news_grandopening_body: '2023年9月19日，南京派特美生科技有限公司（以下简称"派特美生"）举行开业大典。派特美生由南京药石科技股份有限公司（300725）、江苏集萃药康生物科技股份有限公司（688046）、中农宠物营养研究院（江苏）有限公司以及江苏南创化学与生命健康研究院有限公司等投资共建，致力于以科技创新和品质之力护佑全球宠物的创新型企业。派特美生以人用创新药的研发思路和品质控制，通过Biotech研发外包模式加自有工厂的形式，开发包括宠物药物、宠物康复器械及各类功能性食品。公司将不断推进科技创新，提高产品品质和服务水平，为宠物提供高品质的医疗保障和全面的康复和健康管理服务，愿景是成为全球宠物健康产业的领军企业。',
  news_hightech_title: '喜报 | 派特美生成功入选江苏省2025年高新技术企业',
  news_hightech_p1: '作为一家专注于宠物医疗领域的生物科技公司，南京派特美生科技有限公司（下称：派特美生）凭借其在宠物医药研发领域的深耕积淀与创新突破，成功入选江苏省2025年度高新技术企业名单。这一荣誉既是相关部门对公司研发实力的权威认证，更是对企业创新发展路径的高度肯定。此次入选省级高新技术企业，历经企业申请、专家评审、社会公示及异议处理等多轮严苛程序，其含金量不仅体现在荣誉本身，更蕴含着政策扶持、资源对接等多重发展优势，为进一步加大企业研发投入、加速创新成果转化提供了有力保障，更彰显了相关部门对派特美生在宠物医疗领域创新价值的充分认可。',
  news_hightech_p2: '面向未来，派特美生将始终秉承着以科技创新和品质之力护佑全球宠物的愿景，持续推进创新宠物药物研发，满足临床未被满足的需求，解决宠物治疗领域缺医少药的现状。同时，公司还将围绕"一体两翼"战略，持续布局一类创新宠物生物制品，辅以医疗器械和保健品的合作开发，为宠物病患带来更多健康的希望，为全球动物健康水平提升和高质量发展贡献坚实力量。',

  message1: '姓名',
  message2: '请输入名字',
  message3: '邮箱',
  message4: '请输入邮箱',
  message5: '电话',
  message6: '请输入电话',
  message7: '内容',
  message8: '请输入内容',
  message9: '提交',
  message10: '南京派特美生科技有限公司',
  message11: '公司地址',
}



// WEBPACK FOOTER //
// ./src/lang/zh.js